<template>
    <div class="person-visitors d-flex flex-column align-items-center">
        <app-sub-title text="Visitas de Personas" />
        <app-person-visitors-filters
            v-model="filters"
            :onFilter="filterEntries"
        />
        <b-row>
            <b-col>
                <b-btn
                    block
                    @click="reportPersonVisits"
                    title="Descargar"
                    variant="primary"
                >
                    Descargar reporte visitas de personas
                </b-btn>
            </b-col>
        </b-row>
        <div class="alert alert-info" v-if="!data.data || !data.data.length">
            <h4>No hay información</h4>
        </div>
        <div
            class="person-entries-data d-flex flex-column align-items-center"
            v-if="!!data.data && !!data.data.length"
        >
            <app-person-visitors-table :data="data.data" />
            <app-paginator
                :current-page="data.current_page"
                :last-page="data.last_page"
                :from="data.from"
                :to="data.to"
                :per-page="data.per_page"
                :total="data.total"
                :onChangePage="onChangePage"
            />
        </div>
    </div>
</template>
<script>
import SubTitle from '../../UI/Layout/SubTitle.vue'
import PersonVisitorsFilters from './PersonVisitorsFilters/PersonVisitorsFilters.vue'
import PersonVisitorsTable from './PersonVisitorsTable/PersonVisitorsTable.vue'
import Paginator from '../../UI/Controls/Paginator/Paginator.vue'
import peopleRepository from '../../../repositories/people.repository'
export default {
    components: {
        appSubTitle: SubTitle,
        appPersonVisitorsFilters: PersonVisitorsFilters,
        appPersonVisitorsTable: PersonVisitorsTable,
        appPaginator: Paginator,
    },
    data() {
        return {
            filters: '',
            data: '',
            page: 1,
        }
    },
    methods: {
        getPersonEntries() {
            const pr = Object.assign({}, peopleRepository)
            pr.getPersonEntriesByClient(this.client.id, this.page, this.filters)
                .then((data) => {
                    this.data = data
                })
                .catch((error) => {
                    toastr.error('Ocurrió un error al consultar los ingresos')
                })
        },
        reportPersonVisits() {
            const filters = { ...this.filters, clientId: this.client.id }
            const params = []
            _.forIn(filters, (value, key) => {
                if (!value) return
                params.push(`${key}=${value}`)
            })

            const queryString = params.join('&')
            window.open(
                `web/v1/person-entries/client-export?` + queryString,
                '_blank'
            )
        },
        onChangePage(page) {
            this.page = page
            this.getPersonEntries()
        },
        filterEntries() {
            this.page = 1
            this.getPersonEntries()
        },
    },
    created() {
        this.getPersonEntries()
    },
}
</script>
